// The marketing consent shown directly above the submit button on both lead
// forms. Submitting a form is the opt-in this sentence describes: the booking
// service records it on the enquirer's user record and pushes it to Mailchimp
// (see recordLeadMarketingConsent in createLeadInquiry).
//
// Shared by both forms rather than written out twice, so the wording the
// enquirer agreed to cannot drift between the two products -- and so a change
// to it is a single, reviewable edit.
export const LEAD_CONSENT_TEXT =
    "By submitting this form you allow Wezoo to contact you about your " +
    "inquiry and about other relevant offers.";
